<template>
  <div>
    <b-modal v-model="signupModal " hide-footer hide-header size="sm" modal-class="session-modal">
      <template v-slot:default="{ hide }">
        <div class="row ">
          <div class="col-2 px-0"></div>
          <div class="col-7 pr-0 pl-1 ml-2">
            <p class="text-center mt-3 mb-0"><b>Sign up</b></p>
          </div>
          <div class="col-1 px-0">
            <button class="btn btn-md " @click="hide()"><h3>×</h3></button>
          </div>
        </div>

        <validation-observer class="form bg-white" ref="obs" >
          <div class="row mx-2">
            <div class="col-12 mx-auto px-20">
              <validation-provider name="email" rules="required">
                <div slot-scope="mail_adress">
                  <b-input-group class="mt-2 session-input" :class='{"error-input": mail_adress.failed}'>
                    <template #prepend>
                      <b-input-group-text class='session-icon-input'><b-icon icon="envelope-fill"></b-icon></b-input-group-text>
                    </template>
                    <b-form-input placeholder="Email" v-model="email"></b-form-input>
                  </b-input-group>
                  <p v-if="mail_adress.failed" class="error">{{ mail_adress.errors[0] }}</p>
                </div>
              </validation-provider>
            </div>
          </div>

          <div class="row mx-2 mt-2">
            <div class="col-12 mx-auto px-20">
              <validation-provider name="password" rules="required|password">
                <div slot-scope="passwordScope">
                  <b-input-group class=" session-input-side" :class='{"error-input": passwordScope.failed}'>
                    <template #prepend>
                      <b-input-group-text class='session-icon-input'><b-icon icon="lock-fill"></b-icon></b-input-group-text>
                    </template>
                    <b-form-input :type="inputType" placeholder="Password" v-model="password"></b-form-input>
                    <template #append>
                      <b-input-group-text class='session-icon-input-append'><b-icon :icon="icon" @click="switchPassword"></b-icon></b-input-group-text>
                    </template>
                  </b-input-group>
                  <p v-if="passwordScope.failed" class="error">{{ passwordScope.errors[0] }}</p>
                </div>
              </validation-provider>
              <label class="text-gray label-small">{{$t("message.pass_condition")}}</label>
            </div>
          </div>

          <div class="row mx-2 mt-2">
            <div class="col-12 mx-auto px-20">
              <validation-provider name="password_confirm"  rules="required|confirmed:password">
                <div slot-scope="passwordConfirmScope">
                  <b-input-group class=" session-input-side" :class='{"error-input": passwordConfirmScope.failed}'>
                    <template #prepend>
                      <b-input-group-text class='session-icon-input'><b-icon icon="lock-fill"></b-icon></b-input-group-text>
                    </template>
                    <b-form-input :type="inputTypeConfirm" :placeholder="confirm_text" v-model="password_confirm"></b-form-input>
                    <template #append>
                      <b-input-group-text class='session-icon-input-append'><b-icon :icon="iconConfirm" @click="switchPasswordConfirm"></b-icon></b-input-group-text>
                    </template>
                  </b-input-group>
                  <p v-if="passwordConfirmScope.failed" class="error">{{ passwordConfirmScope.errors[0] }}</p>
                </div>
              </validation-provider>
            </div>
          </div>
        </validation-observer>

        <div class="row mt-3">
          <div class="col-10 mx-auto text-center">
            <b-form-checkbox
              v-model="status"
              :value="true"
              :unchecked-value="false"
            >
              <b-button  class="sign_up px-0" style="display: inline;">
                <u>{{$t("message.terms")}}</u>
              </b-button>
              <p class="font13" style="display: inline;">{{$t("message.agreement2")}}</p>
            </b-form-checkbox>
            <p v-if='not_agree' class="error">{{$t('message.check_agree')}}</p>
            <b-button  class="login mt-3 py-2 px-4 width100" @click="signup" >Sign up</b-button>
            <p v-if='isExistUser' class="error">{{$t('message.is_exist_user')}}</p>
          </div>
        </div>

        <div class="row pt-2">
          <div class="col-12 text-center">
            or
          </div>
        </div>

        <div class="row pt-2">
          <div class="col-12 text-center px-0">
            <b-button @click="authFacebook" class='py-0 px-1' variant="light">
              <b-img v-bind="{ width: 55, height:55}" rounded="0" src="../../../assets/top/PC_mobile/icon/facebook-icon.png"></b-img>
            </b-button>
            <b-button @click="authGoogle" class='py-0 px-1' variant="light">
              <b-img v-bind="{ width: 55, height:55}" rounded="0" src="../../../assets/top/PC_mobile/icon/google-icon.png"></b-img>
            </b-button>
            <b-button @click="signIn('LINE')" class='py-0 px-1' variant="light">
              <b-img v-bind="{ width: 55, height:55}" rounded="0" src="../../../assets/top/PC_mobile/icon/line-icon.png"></b-img>
            </b-button>
          </div>
        </div>

        <div class="row pt-3">
          <div class="col-12 text-center">
            <p class="font13 mb-0">※{{$t("message.have_account")}}</p>
            <b-button class="sign_up" @click="showLogin">
              {{$t("message.login")}}
            </b-button>
          </div>
        </div>
      </template>

    </b-modal>
    <confirm-modal ref="confirmModal" @closeModal="closeModal" :email="email"></confirm-modal>
  </div>
</template>
<script>
import ConfirmModal from "@/components/User/Session/ConfirmModal";
import {Auth} from 'aws-amplify';
export default {
  components: {
    ConfirmModal
  },
  props:{
    // signupModal: false
  },
  data() {
    return {
      signupModal: false,
      emailModal: false,
      isChecked: true,
      isCheckedConfirm: true,
      isExistUser: false,
      inputType: 'password',
      inputTypeConfirm: 'password',
      email: "",
      password: "",
      password_confirm: "",
      icon: "eye",
      iconConfirm: "eye",
      confirm_text: this.$i18n.t('message.password_confirm'),
      status: false,
      not_agree: false,
    }
  },
  methods: {
    signup(){
      if(this.status){
        this.not_agree = false
        this.$refs.obs.validate().then(value =>{
          if(value){
            Auth.signUp({username: this.email, password: this.password, attributes: {email: this.email}})
              .then(() =>{
                this.$refs.confirmModal.showModal()
                // this.$store.commit('user/setUserOuth', response.user)

              })
              .catch(error =>{
                if(error.code == "UsernameExistsException"){
                  this.isExistUser = true
                }
                console.log('thsi is errors',error)
              })
            }
          })
      }else{
        this.not_agree = true
      }
    },
    closeModal(){
      this.signupModal = false
    },
    async signIn(provider) {
      Auth.federatedSignIn({ provider });
    },
    showModal(){
      this.signupModal = true
    },
    showLogin(){
      this.closeModal()
      this.$emit('showLogin')
    },
    async authGoogle(){
      await Auth.federatedSignIn({provider: 'Google'})
    },
    authFacebook(){
      Auth.federatedSignIn({provider: 'Facebook'})
    },
    switchPassword(){
      if (this.isChecked) {
        this.isChecked = false
        this.inputType = "text"
        this.icon = "eye-slash"
      } else {
        this.isChecked = true
        this.inputType = "password"
        this.icon = "eye"
      }
    },
    switchPasswordConfirm(){
      if (this.isCheckedConfirm) {
        this.isCheckedConfirm = false
        this.inputTypeConfirm = "text"
        this.iconConfirm = "eye-slash"
      } else {
        this.isCheckedConfirm = true
        this.inputTypeConfirm = "password"
        this.iconConfirm = "eye"
      }
    },
  },
}
</script>
<style scoped lang="scss">
.btn{
  padding: .235rem .75rem;
}
@media (max-width: 768px) {
  .navbar-nav {
    -webkit-box-orient: horizontal !important;
    display: -webkit-box;
  }
}

.modal-header{
  border-bottom: 0px solid #dee2e6;
  text-size: 16px;
  text-align: center!important;
}

.facebook{
  background: #1877F2 !important;
  color: #FFFFFF;
  font-size: 14px;
  width: 90%
}

.sign_up{
  background: #FFFFFF !important;
  color: #F29147 !important;
  border-color: #FFFFFF !important;
  font-size: 14px;

  &:hover {
    box-shadow: none !important;
  }
}

.line {
  border-color: #00B302 !important;
  background: #00B302 !important;
  color: #FFFFFF;
  font-size: 14px;
  width: 90%
}
.label-small{
  font-size: 0.8rem;
}

</style>
